// TODO: odstranit DMS_MODULE je nutno podivat se kde vsude se pouziva
export const DMS_MODULE = 'Sestavy';
export const NAME = 'Sestavy'; 

export enum PagesToLogStats {
	WIP_REPORT = '/Sestavy/WorkInProgress/',
    TIME_CLOCKING_REPORT = '/Servis/TimeClocking/',
	RESERVATION_PAGE = '/Servis/ZakazkaRezervaceNd/',
	ORDER_ARCHVE_PAGE = '/Servis/ZakazkaArchiv/',
	PART_MAITAINANCE_PAGE = '/Nd/NdSklad/',
	SP_PRICE_LIST_PAGE = '/Nd/NdCenik/',
	ISSUE_PARTS_SCREEN = '/Servis/JednotnaFrontaNd/',
	CUSTOMERS_PAGE = '/Kartoteka/Partner/',
	VEHICLES_PAGE = '/Kartoteka/Vozidlo/',
	SERVICE_ORDER_PAGE = '/Servis/Zakazka/',
	REAL_TIME_INVENTORY_REPORT ='/Sestavy/RealTimeInventory/',
	PLANNED_ORDER_PAGE ='/Servis/Ozakazka/',
	REVENUE_DETAILS_REPORT = '/Sestavy/RevenueDetails/'
}
